<nz-pagination
  [nzPageIndex]="pageIndex"
  [nzPageSize]="pageSize"
  [nzTotal]="total"
  [nzSimple]="simpleMode"
  [nzShowQuickJumper]="showQuickJumper"
  [nzSize]="size"
  (nzPageIndexChange)="onPageIndexChange($event)"
  (nzPageSizeChange)="onPageSizeChange($event)"
  nzResponsive
></nz-pagination>
